// מקור אמת אחד לתרגומים, אייקונים וצבעים של קריאות שירות.
// כל שינוי ב-enum בסכמה צריך להשתקף כאן בלבד.

export const REQUEST_STATUSES = {
    open: { label: 'פתוח', icon: 'mdi-folder-open-outline', modifier: 'open' },
    in_progress: { label: 'בביצוע', icon: 'mdi-progress-clock', modifier: 'progress' },
    completed: { label: 'הושלם', icon: 'mdi-check-circle-outline', modifier: 'completed' },
    canceled: { label: 'בוטל', icon: 'mdi-cancel', modifier: 'canceled' },
};

export const REQUEST_PRIORITIES = {
    low: { label: 'נמוכה', icon: 'mdi-chevron-down', modifier: 'low' },
    normal: { label: 'רגילה', icon: 'mdi-minus', modifier: 'normal' },
    high: { label: 'דחופה', icon: 'mdi-chevron-double-up', modifier: 'high' },
};

export const REQUEST_TYPES = {
    new_line: { label: 'הקמת מנוי', icon: 'mdi-sim-outline' },
    porting: { label: 'ניוד', icon: 'mdi-swap-horizontal' },
    ownership_transfer: { label: 'העברת בעלות', icon: 'mdi-account-arrow-right-outline' },
};

// המפתחות זהים ל-operating_company שבתוכניות, כדי שלא יהיה מיפוי כפול בשרת
export const SUPPLIERS = {
    hotMobile: { label: 'הוט מובייל' },
    partner: { label: 'פרטנר' },
    clickCallMobile: { label: 'קליקול מובייל' },
};

// עוזרים לתצוגה – מחזירים תמיד ערך בטוח גם אם הגיע סטטוס לא מוכר מהשרת
export const statusLabel = v => (REQUEST_STATUSES[v] && REQUEST_STATUSES[v].label) || '—';
export const statusIcon = v => (REQUEST_STATUSES[v] && REQUEST_STATUSES[v].icon) || 'mdi-help-circle-outline';
export const statusModifier = v => (REQUEST_STATUSES[v] && REQUEST_STATUSES[v].modifier) || 'open';

export const priorityLabel = v => (REQUEST_PRIORITIES[v] && REQUEST_PRIORITIES[v].label) || '—';
export const priorityIcon = v => (REQUEST_PRIORITIES[v] && REQUEST_PRIORITIES[v].icon) || 'mdi-minus';
export const priorityModifier = v => (REQUEST_PRIORITIES[v] && REQUEST_PRIORITIES[v].modifier) || 'normal';

export const typeLabel = v => (REQUEST_TYPES[v] && REQUEST_TYPES[v].label) || '—';
export const typeIcon = v => (REQUEST_TYPES[v] && REQUEST_TYPES[v].icon) || 'mdi-file-outline';

// ספק שאינו ברשימה מוצג כמו שהוא ולא כ-"—", כדי שערכים ישנים בעברית
// ימשיכו להיראות תקין עד שתריץ מיגרציה
export const supplierLabel = v => {
    if (!v) return '—';
    return (SUPPLIERS[v] && SUPPLIERS[v].label) || v;
};

// רשימות ל-v-select / כפתורי סינון
export const statusOptions = Object.entries(REQUEST_STATUSES).map(([value, o]) => ({ value, ...o }));
export const priorityOptions = Object.entries(REQUEST_PRIORITIES).map(([value, o]) => ({ value, ...o }));
export const typeOptions = Object.entries(REQUEST_TYPES).map(([value, o]) => ({ value, ...o }));
export const supplierOptions = Object.entries(SUPPLIERS).map(([value, o]) => ({ value, ...o }));

/**
 * בונה URL מלא לקובץ ששמור בסכמה כנתיב יחסי, למשל "stream/024039927/tt.jpg".
 * הנתיב מקבל את ה-base של ה-API ואת הטוקן כ-query param, כי תגית <img>
 * לא יכולה לשלוח כותרת Authorization.
 *
 * מקבל אובייקט קובץ (id_card_file / supplier_form_file / attachment) או מחרוזת נתיב.
 */
export const fileUrl = file => {
    const path = typeof file === 'string' ? file : (file && file.path) || '';
    if (!path) return '';

    // נתיב מוחלט (למשל נתוני דמו או CDN חיצוני) – מוחזר כמו שהוא
    if (/^(https?:)?\/\//i.test(path) || /^(blob|data):/i.test(path)) return path;

    const base = (process.env.VUE_APP_BASE_URL || '').replace(/\/+$/, '');
    const clean = path.replace(/^\/+/, '');
    const token = localStorage.getItem('token') || '';
    const separator = clean.includes('?') ? '&' : '?';

    return `${base}/${encodeURI(clean)}`
        + (token ? `${separator}token=${encodeURIComponent(token)}` : '');
};

export default {
    REQUEST_STATUSES,
    REQUEST_PRIORITIES,
    REQUEST_TYPES,
    SUPPLIERS,
    statusLabel,
    statusIcon,
    statusModifier,
    priorityLabel,
    priorityIcon,
    priorityModifier,
    typeLabel,
    typeIcon,
    supplierLabel,
    statusOptions,
    priorityOptions,
    typeOptions,
    supplierOptions,
    fileUrl,
};